import React, { useState, useContext, useEffect, useRef } from 'react'
import './profile.sass'
import { ImageCard, ProfileTabViewer, ConnectionCard, ProfileCardViewerRemote } from '../../components/profile'
import { DarkModeContext } from '../../global/Theme'
import { useHistory } from 'react-router-dom';

import { getUserImagePosts, getUserVideoPosts } from '../../api/feed'
import { useSelector, useDispatch } from 'react-redux'
import { getUserByUsername } from '../../api/auth'
import { starUser, unStarUser, isStarred } from "../../api/social"
import {EmptyScreen} from '../../components/common/EmptyScreen'

export default function ProfileViewer() {
    const [cIndex, setCIndex] = useState(0);
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory()
    const dispatch = useDispatch()

    const [id, setId] = useState("");
    const reduxImagePosts = useSelector(store => store.imagePosts)
    const reduxVideoPosts = useSelector(store => store.videoPosts)
    const [userDataStore, setUserDataStore] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false);
    const [starred, setStarred] = useState(0);
    const [width, setWidth] = useState(document.body.clientWidth);

    const profileTab = useRef();
    const profileWrapper = useRef();
    const rightCol = useRef()

    var header = profileTab;


    // console.log(reduxImagePosts);

    const getUserData = async () => {
        const username = window.location.href.split('user/')[1]
        const res = await getUserByUsername(username)
        setUserDataStore(res);
        setIsLoaded(true);
      
    }

    const getIsStarred = async () => {
        const res = await isStarred(userDataStore);
        if (res) setStarred(1)
        else setStarred(2);
    }

    useEffect(() => {
        getUserData();
    }, [])

    useEffect(() => {
        if(isLoaded && userDataStore != null){
        profileWrapper.current.addEventListener('scroll', () => {
            if (width <= 840) {

                if (((profileWrapper.current.scrollTop + 80) >= header.current.offsetTop) && profileWrapper.current.scrollTop > 230) {
                    header.current.classList.add("sticky");
                    rightCol.current.classList.add('right-column-alt')
                    rightCol.current.classList.remove('right-column')
                } else if ((profileWrapper.current.scrollTop - 200) <= header.current.offsetTop) {
                    header.current.classList.remove("sticky");
                    rightCol.current.classList.remove('right-column-alt')
                    rightCol.current.classList.add('right-column')
                }
            }
        })
    }
    }, [isLoaded, userDataStore])


    useEffect(() => {
        if (userDataStore !== null) {
            setId(userDataStore.id)
            getIsStarred();
        }
    }, [userDataStore])

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const handleStarUser = async () => {
        if (starred == 1) {
            await unStarUser(userDataStore.id)
            
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: `Unstarred ${userDataStore.username}`,
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
            
        } else {
            await starUser(userDataStore.id)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: `Starred ${userDataStore.username}`,
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
        }
        getIsStarred();
    }

    useEffect(()=>{
        document.getElementById('mainWrapper').classList.add('padding')
        document.getElementById('mainWrapper').classList.remove('post')
        if(document.body.clientWidth < 580){
            document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px 70px 10px !important"
        } else {
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
        }
    }, [])

    let temp = [];
    let videoTemp = [];
    useEffect(() => {
        if (id !== "") {
            getUserImagePosts(userDataStore.id, (imagePostObserver) => {
                imagePostObserver.docs.forEach(post => {
                    temp.push(post.data())
                    const fTemp = temp.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                    const sortedTemp = fTemp.sort((x, y) => y.time - x.time)
                    dispatch({
                        type: 'ADD_IMAGE_POST',
                        payload: sortedTemp
                    })
                });

            });

            getUserVideoPosts(userDataStore.id, (videoPostObserver) => {
                videoPostObserver.docs.forEach(post => {
                    videoTemp.push(post.data())
                    const fTemp = videoTemp.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                    const sortedTemp = fTemp.sort((x, y) => y.time - x.time)
                    dispatch({
                        type: 'ADD_VIDEO_POST',
                        payload: sortedTemp
                    })
                });

            })
            if (videoTemp.length == 0) {
                dispatch({
                    type: 'EMPTY_VIDEO_POST'
                })
            }
            if (temp.length == 0) {
                dispatch({
                    type: 'EMPTY_IMAGE_POST'
                })
            }
        }
    }, [id])

    const updateIndex = (e) => {
        setCIndex(e)
    }

    return (
        <div style={{ width: '100%' }}>
            {
                isLoaded && userDataStore != null && <div id="profileWrapper" ref={profileWrapper}>
                    <div id="profileCLeft">
                        <div className={`${isDark ? 'profile-name-card-dark' : 'profile-name-card-light'}`}>
                            <img style={{ zIndex: '2' }} onClick={() => { history.goBack() }} src={require('../../assets/icons/backbutton.svg')}  />
                            <p>{userDataStore.username}</p>
                            <img style={{ zIndex: '2' }} onClick={handleStarUser} src={starred != 0 ? starred == 2 ? require('../../assets/icons/star.svg') : require('../../assets/icons/star_a.svg') : null}  />
                        </div>
                        <ProfileCardViewerRemote userDataStore={userDataStore} />
                    </div>
                    <div id="profileCRight" ref={rightCol}>
                        <div ref={profileTab}>
                        <ProfileTabViewer handleOnClick={updateIndex} activeIndex={cIndex} />
                        </div>
                        {cIndex == 0 ? <div id="postPics">
                            {
                                (reduxImagePosts && reduxImagePosts.length === 0) ? 
                                <EmptyScreen logo='profile_a' heading='No posts available' description={`${userDataStore.username} didn’t shared any posts so far.`} /> :
                                reduxImagePosts && reduxImagePosts.map((v) => <ImageCard thumb={v.thumbnail} username={userDataStore.username} userId={v.user} postId={v.id} img={v.media} type={1} />)
                            }
                        </div> : <div> </div>
                        }

                        {cIndex == 1 ?
                            <div id="postVideos">
                                {
                                    (reduxImagePosts && reduxImagePosts.length === 0) ? 
                                    <EmptyScreen logo='profile_a' heading='No posts available' description={`${userDataStore.username} didn’t shared any posts so far.`} /> :
                                    reduxVideoPosts && reduxVideoPosts.map((v) => <ImageCard thumb={v.thumbnail} username={userDataStore.username} userId={v.user} postId={v.id} img={v.media} type={2} />)
                                }
                            </div> : <div> </div>}

                        {cIndex == 2 ?
                            <div id="postBM">
                                <ImageCard isLocked={true} img="img2.png" />
                                <ImageCard img="img2.png" />
                                <ImageCard img="img2.png" />
                                <ImageCard img="img2.png" />
                            </div> : <div> </div>}

                        {(cIndex == 3) ?
                            <div id="postConnections">
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type="website" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.website.length > 0) ? true : false} img='website.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.website.length > 0) ? userDataStore.socialMedia.website : "#"} />
                                    <ConnectionCard type="instagram" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.instagram.length > 0) ? true : false} img='instagram.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.instagram.length > 0) ? userDataStore.socialMedia.instagram : "#"} />
                                </div>
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type="spotify" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.spotify.length > 0) ? true : false} img='spotify.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.spotify.length > 0) ? userDataStore.socialMedia.spotify : "#"} />
                                    <ConnectionCard type="tiktok" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.tiktok.length > 0) ? true : false} img='tiktok.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.tiktok.length > 0) ? userDataStore.socialMedia.tiktok : "#"} />
                                </div>
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type="pornhub" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.pornhub.length > 0) ? true : false} img='pornhub.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.pornhub.length > 0) ? userDataStore.socialMedia.pornhub : "#"} />
                                    <ConnectionCard type="snapchat" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.snapchat.length > 0) ? true : false} img='snapchat.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.snapchat.length > 0) ? userDataStore.socialMedia.snapchat : "#"} />
                                </div>
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type="twitter" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.twitter.length > 0) ? true : false} img='twitter.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.twitter.length > 0) ? userDataStore.socialMedia.twitter : "#"} />
                                    <ConnectionCard type="twitch" isActive={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.twitch.length > 0) ? true : false} img='twitch.png' page={(userDataStore.socialMedia !== undefined && userDataStore.socialMedia.twitch.length > 0) ? userDataStore.socialMedia.twitch : "#"} />
                                </div>
                            </div> : <div> </div>}

                    </div>
                </div>
            }
        </div>
    )
}
